export default "__VITE_ASSET__CasGLzEL__"